<template>
  <div>
    <PageTitle
    :main="$t('cadastro-de-equipamentos')"
    sub=""
    imagem="dashboard.png"
    />
    <GridEquipments></GridEquipments>
  </div>
</template>

<script>
import PageTitle from '../template/PageTitle.vue';
import GridEquipments from './GridEquipments.vue';

export default {
  name:"Equipment",
  components: { GridEquipments, PageTitle }
}
</script>

<style scoped>

</style>